import { render, staticRenderFns } from "./corpTag.vue?vue&type=template&id=b47d70c8&scoped=true&"
import script from "./corpTag.vue?vue&type=script&lang=js&"
export * from "./corpTag.vue?vue&type=script&lang=js&"
import style0 from "./corpTag.vue?vue&type=style&index=0&id=b47d70c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d70c8",
  null
  
)

export default component.exports